import { resetGatewaysState } from '@common/modules/gateways/stores/gateways.actions'

import { useProjectsStore } from '../stores/projects.store'
import type { Project } from '../types/project.types'

export function switchCurrentProject(project: Project): void {
  const previousId = useProjectsStore.getState().currentProject?.id
  if (previousId !== project.id) {
    resetGatewaysState()
  }
  useProjectsStore.getState().setCurrentProject(project)
}
